var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pages-ccd-tenancy-view" },
    [
      _c(
        "TenancyHeader",
        [
          _c(
            "template",
            { slot: "header-top" },
            [
              _c("HKLHeader", {
                attrs: {
                  "label-left-primary": _vm.tenancyHklLeftPrimaryLabel,
                  "link-class-left-primary": "back",
                  "label-right-leading": _vm.$t(
                    "listNavigation.previousRecord"
                  ),
                  "label-right-trailing": _vm.$t("listNavigation.nextRecord"),
                  "navigation-entries": _vm.tenancyListNavEntriesForHeader,
                  "current-record-id": _vm.$route.params.id,
                },
                on: {
                  "left-primary": _vm.onTenancyHklLeftPrimary,
                  "right-leading": _vm.onTenancyListNavEntry,
                  "right-trailing": _vm.onTenancyListNavEntry,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Sticky",
            {
              staticClass: "sticky-header",
              attrs: {
                extendStickyClass: "sticky-button--group",
                fullWidth: false,
                zIndex: Number(101),
                align: "right",
              },
            },
            [
              _vm.showEditBtn
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange edit",
                      class: {
                        "tenant-edit":
                          _vm.isTenant ||
                          (_vm.canCreateProjects && !_vm.hiddenCreateButton),
                      },
                      attrs: { type: "button", disabled: _vm.disabledEditBtn },
                      on: {
                        click: function () {
                          return _vm.goEdit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.edit")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isTenantOrMarketing &&
              _vm.isContactTab &&
              _vm.isTenantOrMarketingEditing
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--darkblue edit tenant-edit",
                      attrs: { type: "button" },
                      on: {
                        click: function () {
                          return _vm.cancelEdit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.cancel")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isTenantOrMarketing &&
              _vm.isContactTab &&
              _vm.isTenantOrMarketingEditing
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange edit tenant-edit",
                      attrs: { type: "button" },
                      on: {
                        click: function () {
                          return _vm.save()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.save")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canCreateProjects &&
              !_vm.hiddenCreateButton &&
              _vm.enableTenantProjectsFeature
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange edit",
                      attrs: { type: "button" },
                      on: {
                        click: function () {
                          return _vm.openTermsConditions()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("newProject")) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabs-container-wrapper" },
        [
          _c("DynamicTabsContainer", {
            ref: "dynamicTabsContainer",
            staticClass: "tabs-container",
            attrs: {
              currentTabIndex: _vm.currentTabIndex,
              tabTemplates: _vm.currentTabTemplates,
            },
            on: {
              tabIndex: function () {
                var args = [],
                  len = arguments.length
                while (len--) args[len] = arguments[len]

                return _vm.getCurrentTab.apply(void 0, args)
              },
              tabClick: function () {
                var args = [],
                  len = arguments.length
                while (len--) args[len] = arguments[len]

                return _vm.onActiveTab.apply(void 0, args)
              },
            },
          }),
          _vm._v(" "),
          _vm.canAccessProjects
            ? _c("TermsAndConditions", {
                ref: "tncTenancyPage",
                attrs: {
                  modalId: "tncTenancyPage",
                  companyName: _vm.companyName,
                  isNewProject: true,
                  acceptCallback: _vm.termsConditionsCallback,
                  skipCallback: _vm.termsConditionsCallback,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "create-tenantproject-without-premisespair-hint",
          attrs: {
            modalId: "create-tenantproject-without-premisespair-hint",
            showCloseBtn: false,
            modalType: "customized-modal",
          },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("pre", { staticClass: "font-bold" }, [
              _vm._v(_vm._s(_vm.$t("tenantProjects.withoutPremisesPair"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: {
                  click: function () {
                    return _vm.closeModal(
                      "create-tenantproject-without-premisespair-hint"
                    )
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "personalInfoProtectModal",
        attrs: {
          confirmTitle: _vm.$t("pipl.content"),
          confirmBtnName: _vm.$t("action.yes"),
          cancelBtnName: _vm.$t("action.cancel"),
          modalId: "personal-info-protect-modal",
        },
      }),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "emptyContactHint", attrs: { modalId: "empty-contact-hint" } },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.emptyContactHintContent) + "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function () {
                    return _vm.closeModal("emptyContactHint")
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("action.ok")) + "\n      ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }